@if (isVisible) {
  <div
    #container
    class="rkt-filter-menu"
    [@overlayAnimation]="{
      value: 'visible',
      params: { showTransitionParams: '50ms linear', hideTransitionParams: '50ms linear' },
    }"
    (@overlayAnimation.start)="captureStartEvent($event)"
  >
    <div class="rkt-filter-menu-content">
      <div class="filters-scroll-area">
        @for (filter of filters; track filter) {
          <div class="filter-scroll-item">
            @if (filter.type === 'RADIO') {
              <app-filter-radio-group
                [options]="filter.options!"
                [props]="filter.props"
                (changed)="setFilterValue(filter.name, $event)"
                (filterToggled)="onFilterToggle()"
                [selectedValue]="values[filter.name]"
                [defaultValue]="filter.defaultValue"
                [filterName]="filter.displayName"
                [isCollapsable]="isFilterCollapsable"
              ></app-filter-radio-group>
            }
            @if (filter.type === 'CHECKLIST') {
              <app-filter-checklist
                [options]="filter.options!"
                [props]="filter.props"
                (changed)="setFilterValue(filter.name, $event)"
                (filterToggled)="onFilterToggle()"
                [selectedValue]="values[filter.name]"
                [filterName]="filter.displayName"
                [defaultValue]="filter.defaultValue"
              ></app-filter-checklist>
            }
            @if (filter.type === 'INPUT') {
              <app-filter-input
                [props]="filter.props"
                (changed)="setFilterValue(filter.name, $event)"
                (filterToggled)="onFilterToggle()"
                [selectedValue]="values[filter.name]"
                [filterName]="filter.displayName"
                (errored)="setFieldErrorState(filter.name, $event)"
                [isCollapsable]="isFilterCollapsable"
              ></app-filter-input>
            }
            @if (filter.type === 'AMOUNT') {
              <app-filter-amount
                [props]="filter.props"
                (changed)="setFilterValue(filter.name, $event)"
                (filterToggled)="onFilterToggle()"
                [selectedValue]="values[filter.name]"
                [filterName]="filter.displayName"
                (errored)="setFieldErrorState(filter.name, $event)"
                [isCollapsable]="isFilterCollapsable"
              ></app-filter-amount>
            }
            @if (filter.type === 'DATE' || filter.type === 'CUSTOM_DATE') {
              <app-filter-date
                [options]="filter.options!"
                [props]="filter.props"
                (changed)="setFilterValue(filter.name, $event)"
                (edit)="onEditClick(filter)"
                (filterToggled)="onFilterToggle()"
                [selectedValue]="values[filter.name]"
                [defaultValue]="filter.defaultValue"
                [filterName]="filter.displayName"
                [fieldError]="errors[filter.name]"
                [isCalendarVisible]="getCalendarVisibility(filter.name)"
                [isCollapsable]="isFilterCollapsable"
              ></app-filter-date>
            }
          </div>
        }
      </div>
    </div>
    @for (filter of customerDateFilters; track filter) {
      <app-filter-custom-date-selector
        [selectedValue]="values[filter.name]"
        [props]="filter.props"
        [showCalendar]="getCalendarVisibility(filter.name)"
        (changed)="setFilterValue(filter.name, $event)"
        (errored)="setFieldErrorState(filter.name, $event)"
        (closed)="closeCalendar(filter.name)"
      ></app-filter-custom-date-selector>
    }
    @for (filter of dateRangeFilters; track filter) {
      <app-filter-custom-date-range-selector
        [calendarDisplayName]="filter.displayName"
        [selectedValue]="values[filter.name]"
        [props]="filter.props"
        [showCalendar]="getCalendarVisibility(filter.name)"
        (changed)="setFilterValue(filter.name, $event)"
        (errored)="setFieldErrorState(filter.name, $event)"
        (closed)="closeCalendar(filter.name)"
      ></app-filter-custom-date-range-selector>
    }
    <div class="rkt-filter-menu-buttons">
      <button rktButton btnType="danger" (click)="onResetAllFilterBtnClick()">Reset All</button>
      <button rktButton (click)="onApplyFilterBtnClick()" [disabled]="isFilterHasErrors">Apply</button>
    </div>
  </div>
}
